module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/fallback_469_625_615b6be.jpg";